/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contributions_KickerInputs */

const en_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const ar_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const bn_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const de_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const es_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const fr_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const pt_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const zh_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const tr_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const ru_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

const pl_contributions_kicker = /** @type {(inputs: Contributions_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github/contributions`)
};

/**
* | output |
* | --- |
* | "github/contributions" |
*
* @param {Contributions_KickerInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_kicker = /** @type {((inputs?: Contributions_KickerInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_KickerInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_kicker(inputs)
	if (locale === "bn") return bn_contributions_kicker(inputs)
	if (locale === "de") return de_contributions_kicker(inputs)
	if (locale === "es") return es_contributions_kicker(inputs)
	if (locale === "fr") return fr_contributions_kicker(inputs)
	if (locale === "pt") return pt_contributions_kicker(inputs)
	if (locale === "zh") return zh_contributions_kicker(inputs)
	if (locale === "tr") return tr_contributions_kicker(inputs)
	if (locale === "ru") return ru_contributions_kicker(inputs)
	if (locale === "pl") return pl_contributions_kicker(inputs)
	return en_contributions_kicker(inputs)
});